import gele from '../core/gele.js';
/**
 * Same as {@link gele}.
 */
const between = gele;
export default between;
